import { DEFAULT_USER, INTEGRATION_DOCUMENT } from '~/consts/psf';
import apiPSFAnon from '~/services/apiPSFAnon';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import { getRawDocument } from '~/utils/string';

interface Params {
  transactionNumber: string;
  quotationNumber?: string;
  certificateCode?: string;
  protocol?: string;
  document: string;
  totalPrize: number;
  type: 'AUTO' | 'MARISACUIDA' | 'BOLSAPROTEGIDA' | 'PERDARENDA';
}

export async function registerContractUseCase({
  transactionNumber,
  quotationNumber,
  certificateCode,
  protocol,
  document,
  totalPrize,
  type,
}: Params) {
  const [origin] = MarisaAppUtils.getOriginTypeInfos();

  await apiPSFAnon.post('pssservices/api/oInsurence/registrarEfetivacao', {
    cpfUsuario: Number(INTEGRATION_DOCUMENT),
    loginUsuario: DEFAULT_USER,
    ipUsuario: '10.10.10.10',
    idProcesso: '202020202020',
    idServico: '49404049409090',
    service: 'oInsurence',
    functionality: 'registrarIntencao',
    filial: 1033,
    origem: origin,
    fluxo: 'OFERTA_SEGUROS',
    modulo: '2',
    vlrPremioTotal: totalPrize,
    numTransacao: transactionNumber,
    numBilhete: type === 'AUTO' ? protocol : certificateCode,
    descObservacao: 'Não informado',
    numCotacao: quotationNumber ?? certificateCode,
    cpfCnpj: getRawDocument(document),
    tipoPessoa: 'FISICA',
  });
}
